export enum EShowHeaderFooter {
  All = 'all',
  First = 'first',
  Last = 'last',
  Both = 'first-last',
  None = 'none'
}

export const TOC_FONT_TYPES = [
  { label: 'Helvetica', value: 'Helvetica' },
  { label: 'Times', value: 'Times' },
  { label: 'Courier', value: 'Courier' },
  { label: 'DM Sans', value: 'DMSans' }
] as const;
export type ITocFontType = (typeof TOC_FONT_TYPES)[number]['value'];

export enum ETocSeparator {
  Whitespace = 'whitespace',
  Dotted = 'dotted'
}

export type IPublicationSetupPdfStyle = {
  id: string;
  publicationId: string | null;
  sectionId: string | null;
  coverStoryId: string | null;
  pageMargins: {
    top: string;
    bottom: string;
    left: string;
    right: string;
  } | null;
  headerControls: {
    showPageLabel: boolean;
    pageLabelAlignment: 'left' | 'right' | 'interchange';
    showHeaderOn: EShowHeaderFooter;
  };
  footerControls: {
    showFolderName: boolean;
    showTimestamp: boolean;
    showPageNumber: boolean;
    pageNumberOption: EShowPageNumbers;
    showFooterOn: EShowHeaderFooter;
  };
  tocStyles: {
    separator: ETocSeparator;
    fontType: ITocFontType;
  };
  tocData: string;
  watermark: string | null;
  createdBy: string;
  storyStates: string[] | null;
};

export type IHeaderControls = IPublicationSetupPdfStyle['headerControls'];
export type IFooterControls = IPublicationSetupPdfStyle['footerControls'];
export type ITocStyles = IPublicationSetupPdfStyle['tocStyles'];

export const DEFAULT_PAGE_MARGINS = {
  top: '0.25',
  bottom: '0.25',
  left: '1',
  right: '1'
};

export const DEFAULT_HEADER_CONTROLS: IHeaderControls = {
  showPageLabel: false,
  pageLabelAlignment: 'left',
  showHeaderOn: EShowHeaderFooter.All
};

export enum EShowPageNumbers {
  FromFirstPage = 'fromFirstPage',
  OnlyAfterToc = 'onlyAfterToc'
}

export const DEFAULT_FOOTER_CONTROLS: IFooterControls = {
  showPageNumber: false,
  pageNumberOption: EShowPageNumbers.FromFirstPage,
  showFolderName: false,
  showTimestamp: false,
  showFooterOn: EShowHeaderFooter.All
};

export const TOC_NODE_ID = 'toc_node';

export const DEFAULT_TOC_STYLES: ITocStyles = {
  separator: ETocSeparator.Whitespace,
  fontType: TOC_FONT_TYPES[0].value
};
